<template>
    <div id="app">
        <keep-alive>
            <router-view  v-if="!$route.meta.noKeepAlive"/>
        </keep-alive>
        <router-view v-if="$route.meta.noKeepAlive"></router-view>
    </div>
</template>

<script>
export default {
    name: 'App'
}
</script>
<style>
@import "./assets/font/font.css";

body {
    font-family: "D-D","SF",  sans-serif;
    background-color: var(--bg-color-1);
    color: var(--text-color-1);
    width: 375px;
    margin: 0 auto 20px;
    -webkit-text-size-adjust: none !important;
    letter-spacing: 0.5px;
}

header {
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 99999999;
}

.content-body {
    margin-top: 100px;
}

.banner {
    /*border-bottom: 1px solid #333333;*/
    text-align: center;
    height: 44px;
    background-color: var(--bg-color-1);
    padding-top: 44px;
}

.back-icon {
    width: 24px;
    height: 24px;
    margin: 10px 16px;
    float: left;
}

.banner-title {
    font-size: 15px;
    text-align: center;
    margin: 15px 0;
    line-height: 14px;
    color: var(--text-color-1);
    letter-spacing: 2px;
}

.van-dialog {
    background: var(--bg-color-2);
}

.van-button--default {
    background: var(--bg-color-2);
}

.van-overlay {
    background-color: rgba(0, 0, 0, 0.5);
}

[class*=van-hairline]::after {
    border-top: 2px solid var(--text-color-2);
    border-bottom: 2px solid var(--text-color-2);
}

.van-button {
    font-size: 15px;
}

.van-dialog__header {
    font-size: 18px;
}

.van-dialog__message {
    font-size: 15px;
    line-height: 1.5;
    color: var(--text-color-1);
    text-align: left;
}

.van-toast {
    background-color: #404040;
    font-size: 12px;
}

.color-bg-ls {
    color: var(--chart-color-1);
}

.color-bg-ls {
    background-color: var(--chart-color-1);
}

.right-icon {
    width: 24px;
    height: 24px;
    margin: 10px 16px;
    float: right;
}

.desc-content {
    padding-top: 88px;
}

.desc-box {
    width: 345px;
    margin: 10px auto;
    background-color: var(--bg-color-2);
    border-radius: 13px;
}

.desc-title {
    color: var(--text-color-1);
    font-size: 15px;
    padding: 16px 0 8px 16px;
    letter-spacing: 2px;
}

.desc-info {
    color: var(--text-color-2);
    font-size: 13px;
    line-height: 18px;
    margin: 0 8px 0px 16px;
    letter-spacing: 0.5px;
}

.last-desc {
    padding-bottom: 15px;
}

.time-box {
    width: 343px;
    height: 21px;
    background: var(--bg-color-2);
    border-radius: 8px 8px 8px 8px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    padding: 4px;
    font-size: 10px;
    text-align: center;
    letter-spacing: 2px;
    color: var(--text-color-2);
}

.time-item {
    width: 168px;
    height: 21px;
    border-radius: 6px 6px 6px 6px;
    line-height: 21px;
}

.time-active {
    background-color: var(--bg-color-contrary);
    color: var(--text-color-contrary);
}


.time-icon {
    width: 16px;
}

.time-date {
    display: inline-block;
    width: 201px;
    font-size: 15px;
    color: var(--text-color-1);
    letter-spacing: 1.5px;
}


.time-select {
    text-align: center;
    margin-top: 15px;
    position: relative;
    font-size: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.content {
    padding-top: 96px;
}

.time-box {
    width: 343px;
    height: 21px;
    background: var(--bg-color-2);
    border-radius: 8px 8px 8px 8px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    padding: 4px;
    font-size: 12px;
    text-align: center;
    letter-spacing: 2px;
    color: var(--text-color-3);
}

.desc-last {
    padding-bottom: 16px;
}

.arr-opacity {
    opacity: 0.2;
}

.math-box {
    width: 345px;
    height: 66px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 0 auto 10px;
}

.math-item {
    text-align: center;
    margin-top: 11px;
}

.math-num {
    font-size: 24px;
    line-height: 24px;
    color: var(--text-color-1);
    margin-bottom: 4px;
}

.math-text {
    font-size: 13px;
    color: var(--text-color-2);
    line-height: 10px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue